import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=b306566a&scoped=true"
import script from "./CompanyProfile.vue?vue&type=script&lang=js"
export * from "./CompanyProfile.vue?vue&type=script&lang=js"
import style0 from "./CompanyProfile.vue?vue&type=style&index=0&id=b306566a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b306566a",
  null
  
)

export default component.exports